import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { AppModule } from './app/app.module';
enableProdMode();
platformBrowserDynamic().bootstrapModule(AppModule, [{ defaultEncapsulation: ViewEncapsulation.None }]);
